let initialised = false;

export default function () {
    const nuxtApp = useNuxtApp();

    const init = async function () {
        if (initialised) return true;
        if (!import.meta.client) return false;
        await import('v3-infinite-loading/lib/style.css'); // required if you're not going to override default slots
        const InfiniteLoading = await import('v3-infinite-loading');
        nuxtApp.vueApp.component('infinite-loading', InfiniteLoading.default);
        initialised = true;
        return true;
    };

    return {init};
}
